<jqxDropDownButton #myDropDownButton [width]="330" [height]="40">
    <jqxTreeGrid [width]="327" [source]="dataAdapter" [sortable]="true" [columns]="columns"
        (onRowSelect)="CellclickOnEdit($event)" [ready]="ready" [height]="400" [filterable]="true" [showHeader]="false"
        #myTree>
    </jqxTreeGrid>
</jqxDropDownButton>
<div class="row" *ngIf="isSelected">
    <div class="col-24">
        <p><strong>Hierarchy:</strong>{{this.selectedOrgIPVString}}</p>
    </div>
</div>